import { Injectable } from '@angular/core';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { ChecklistItem } from '../__interfaces/ChecklistItem';
import { GroupedChecklist } from '../__interfaces/GroupedChecklist';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  selectedClientId;
  
  constructor(private guiFlow: GuiFlowService) { }

  addProduct(newProduct,list){
    if(list){
      list.push(newProduct);
    }else{
      list = [];
      list.push(newProduct);
    }
    return list;
  }

  getCurrentDate(format){
    let today = new Date();
    let res;
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    format == 'mm/dd/yyyy'? res = mm + '/' + dd + '/' + yyyy : res = yyyy + '/' + mm + '/' + dd;;
    
    return res;
  }

  copyToClipboard(text){
    navigator.clipboard.writeText(text);
    this.guiFlow.openSimpleSnackBar('Copied to clipboard 💾','info');
  }

  isQuestionUnanswered(question){   
    return !question || question == undefined || question == null || question.length == 0;
  }

  isDateEmpty(date){
    return !date || date == "0000-00-00";
  }

  getShortDate(shortDate){
    var mydate = new Date(shortDate);
    var month = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"][mydate.getMonth()];
    var str = month + ' ' + mydate.getFullYear();
    if(str){
      return str;
    }else{
      return 'No definida';
    }
  }

  getMonthsRemaining(d1,d2){
    var months;
    if(d1){
      var months;
      d1 = new Date(d1);
      d2 = new Date(d2);
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }else{
      let today = new Date();
      d2 = new Date(d2);
      months = (d2.getFullYear() - today.getFullYear()) * 12;
      months -= today.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }
  }
  
  calculateAge(birthDateString) {
    const birthDate = new Date(birthDateString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
  }

  getSelectedClientId(){
    return this.selectedClientId;
  }

  setSelectedClientId(id){
    this.selectedClientId = id;
  }

  // PACKS
  generateRandomNumber4Digit(){
    var val = Math.floor(1000 + Math.random() * 9000);
    return val;
  }

  generateRandomNumber(){
    return Date.now() + Math.floor(Math.random() * 100);
  }

  removeObjectWithId(arr, id) {
    var index = arr.map(x => {
      return x.id;
    }).indexOf(id);
    
    arr.splice(index, 1);
    return arr;
  }

  // Get object keys dynamically
  objectKeys(obj: any): string[] {
    return Object.keys(obj || {});
  }

  // Check if a value is a URL
  isUrl(value: string): boolean {
    const urlRegex =
      /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlRegex.test(value);
  }

  areAllFieldsNotNull(obj: { [key: string]: any }) {
    return Object.values(obj).every(value => value !== null);
  }

  generateRandomNumber6Digit(){
    var val = Math.floor(100000 + Math.random() * 9000);
    return val;
  }

  rand() {
    return Math.random().toString(36).substr(2); // remove `0.`
  }

  generateToken() {
    return this.rand() + this.rand(); // to make it longer
  }

  groupChecklists(data: ChecklistItem[]) {
    let groups = data.reduce((acc, item) => {
      const group = acc.find(g => g.checklist_id === item.checklist_id);
      if (group) {
        group.items.push(item);
      } else {
        acc.push({
          checklist_id: item.checklist_id,
          name: item.name,
          items: [item]
        });
      }
      return acc;
    }, [] as GroupedChecklist[]);
    return groups;
  }

  arrayHasElement(array: any[], element: any) {
    let   arrayHasElemetIndexCache = null;
    for (let [index,obj] of array.entries()) {
      if (obj === element) {
        arrayHasElemetIndexCache = index;
        return true;
      }
    }
    arrayHasElemetIndexCache = -1;
    return false;
  }

  arrayHasElementByLabel(arr, label,element) {
    var bird = arr.find(bird => bird[label] === element);
    return bird;
  }

    searchForObjectInArrayByCrudId(array, id){
    for (let [index,obj] of array.entries()) {
      if (obj.id === id) {
        return index;
      }
    }
    return -1;
    
  }
}
